import React, { useContext, useEffect, useState } from 'react'

import BasicInfo from './Components/BasicInformation'
import Address from './Components/Address'
import Photos from './Components/Photos'
import UploadDocument from './Components/UploadDocument'
import classNames from 'classnames'
import { useNavigate, useParams } from 'react-router-dom'
import { apiGet } from 'utils/apiFetch'
import pathObj from 'utils/apiPath'
import { t } from 'i18next'
import useToastContext from 'hooks/useToastContext'
import AuthContext from 'context/AuthContext'
import InitialValidation from './Components/InitialValidation'
import { isEmpty } from 'lodash'
const tabBtnClass =
  'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_INTIAL_VALIDATION = 'initial_validation'
const TAB_BASIC_INFO = 'basic_info'
export const TAB_ADDRESS = 'address'
export const TAB_PHOTOS = 'photos'
export const TAB_UPLOAD_DOCUMENTS = 'upload_documents'

const TABS = {
  TAB_BASIC_INFO,
  TAB_ADDRESS,
  TAB_PHOTOS,
  TAB_UPLOAD_DOCUMENTS
}

function Property (props) {
  const notification = useToastContext()
  const { Id } = useParams()
  const { defaultCountry } = useContext(AuthContext)
  const navigate = useNavigate()
  const [defaultTab, setTab] = useState('basic_info')
  const [propertyId, setPropertyId] = useState(Id ?? '')
  const [editProperty, setEditProperty] = useState('')
  const handleTabClick = (action, e) => {
    setTab(action)
  }

  const setPropertyIdAndTabFn = (Ids, tab) => {
    setPropertyId(Ids)
    setTab(tab)
  }
  const getPropertyById = async () => {
    const result = await apiGet(
      `${pathObj.propertyDetailsById}?propertyId=${propertyId}`
    )
    const theProperty = result?.data?.results || {}
    //if (!theProperty.fromThirdParty) {
      setEditProperty(result?.data?.results)
    // } else {
    //   notification.error('Sorry, This property non editable.')
    //   navigate('/properties')
    // }
    // }
  }

  useEffect(() => {
    if (propertyId) {
      getPropertyById()
    }
    
  }, [defaultTab])  

  useEffect(() => {
    if (defaultCountry !== 'sa') {
      return
    }

    TABS['TAB_INTIAL_VALIDATION'] = TAB_INTIAL_VALIDATION

    if (propertyId) {
      return
    }

    setTab(TAB_INTIAL_VALIDATION)

  }, [defaultCountry, propertyId])

  return (
    <>
      <div className='basic_info px-8'>
        <h3 className='text-xl font-semibold'>{t('UPLOAD_LISTING')}</h3>

        <div className='py-3 my-2'>
          <ul className='border-b flex'>
            {
              defaultCountry === 'sa' && (
            <li className='mr-0 xl:mr-5'>
              <button
                onClick={handleTabClick.bind(this, TAB_INTIAL_VALIDATION)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_INTIAL_VALIDATION,
                  [tabBorderNoneClass]: defaultTab !== TAB_INTIAL_VALIDATION
                })}
              >
                {t('INITIAL_VALIDATION')}
              </button>
            </li>
              )
            }
          
            <li className='mr-0 xl:mr-5'>
              <button
                disabled={defaultCountry === 'sa' && isEmpty(editProperty)}
                onClick={handleTabClick.bind(this, TAB_BASIC_INFO)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_BASIC_INFO,
                  [tabBorderNoneClass]: defaultTab !== TAB_BASIC_INFO
                })}
              >
                {t('BASIC_INFO')}
              </button>
            </li>
            <li className='mx-0 xl:mx-5'>
              <button
                disabled={propertyId === ''}
                onClick={handleTabClick.bind(this, TAB_ADDRESS)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_ADDRESS,
                  [tabBorderNoneClass]: defaultTab !== TAB_ADDRESS
                })}
              >
                {t('SUB_ADMIN_ADDRESS')}
              </button>
            </li>
            <li className='mx-0 xl:mx-5'>
              <button
                disabled={editProperty?.city === '' || !editProperty?.city}
                onClick={handleTabClick.bind(this, TAB_PHOTOS)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_PHOTOS,
                  [tabBorderNoneClass]: defaultTab !== TAB_PHOTOS
                })}
              >
                {t('PHOTOS')}
              </button>
            </li>
            <li className='mx-0 xl:mx-5'>
              <button
                disabled={!editProperty?.photos?.length}
                onClick={handleTabClick.bind(this, TAB_UPLOAD_DOCUMENTS)}
                className={classNames({
                  [tabBtnClass]: true,
                  [tabActiveClass]: defaultTab === TAB_UPLOAD_DOCUMENTS,
                  [tabBorderNoneClass]: defaultTab !== TAB_UPLOAD_DOCUMENTS
                })}
              >
                {t('UPLOAD_DOCUMENTS')}
              </button>
            </li>
          </ul>
        </div>
        {
          defaultTab === TAB_INTIAL_VALIDATION && (
            <InitialValidation
            propertyId={propertyId}
              setTab={setTab}
              editProperty={editProperty}
              setEditProperty={setEditProperty}
              setPropertyIdAndTabFn={setPropertyIdAndTabFn}
            />
          )
        }
        {defaultTab === TAB_BASIC_INFO && (
          <BasicInfo
            tabs={TABS}
            propertyId={propertyId}
            editProperty={editProperty}
            setPropertyIdAndTabFn={setPropertyIdAndTabFn}
          />
        )}
        {defaultTab === TAB_ADDRESS && (
          <Address
            tabs={TABS}
            propertyId={propertyId}
            editProperty={editProperty}
            setPropertyIdAndTabFn={setPropertyIdAndTabFn}
            setTab={setTab}
          />
        )}
        {defaultTab === TAB_PHOTOS && (
          <Photos
            tabs={TABS}
            propertyId={propertyId}
            setTab={setTab}
            editProperty={editProperty}
            setPropertyIdAndTabFn={setPropertyIdAndTabFn}
            getPropertyById={getPropertyById}
          />
        )}
        {defaultTab === TAB_UPLOAD_DOCUMENTS && (
          <UploadDocument
            tabs={TABS}
            setTab={setTab}
            propertyId={propertyId}
            editProperty={editProperty}
            setPropertyIdAndTabFn={setPropertyIdAndTabFn}
          />
        )}
      </div>
    </>
  )
}

export default Property
